// API utility with axios wrapper
console.log('🚀 [api.js] Ładowanie modułu api.js');

import axios from 'axios';

console.log('✅ [api.js] Axios załadowany:', axios);

const API_BASE = '';
console.log('🌐 [api.js] API_BASE:', API_BASE);

// httpOnly cookie is sent automatically with withCredentials: true
export const api = {
  async get(endpoint) {
    console.log('🌐 [api.js] GET request:', endpoint);
    try {
      const url = `${API_BASE}/.netlify/functions${endpoint}`;
      console.log('📡 [api.js] Pełny URL:', url);
      const response = await axios.get(url, {
        withCredentials: true
      });
      console.log('✅ [api.js] GET response:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ [api.js] GET error:', error.message);
      const err = new Error(error.response?.data?.error || error.message);
      err.status = error.response?.status;
      throw err;
    }
  },
  
  async post(endpoint, data) {
    try {
      const response = await axios.post(`${API_BASE}/.netlify/functions${endpoint}`, data, {
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json'
        }
      });
      return response.data;
    } catch (error) {
      const err = new Error(error.response?.data?.error || error.message);
      err.status = error.response?.status;
      throw err;
    }
  },
  
  async patch(endpoint, data) {
    try {
      const response = await axios.patch(`${API_BASE}/.netlify/functions${endpoint}`, data, {
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json'
        }
      });
      return response.data;
    } catch (error) {
      const err = new Error(error.response?.data?.error || error.message);
      err.status = error.response?.status;
      throw err;
    }
  },

  async put(endpoint, data) {
    try {
      const response = await axios.put(`${API_BASE}/.netlify/functions${endpoint}`, data, {
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      const err = new Error(error.response?.data?.error || error.message);
      err.status = error.response?.status;
      throw err;
    }
  },
  
  async delete(endpoint) {
    try {
      const response = await axios.delete(`${API_BASE}/.netlify/functions${endpoint}`, {
        withCredentials: true
      });
      return response.data;
    } catch (error) {
      const err = new Error(error.response?.data?.error || error.message);
      err.status = error.response?.status;
      throw err;
    }
  },
  
  async getBlob(endpoint) {
    try {
      const response = await axios.get(`${API_BASE}/.netlify/functions${endpoint}`, {
        withCredentials: true,
        responseType: 'blob'
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || error.message);
    }
  }
};
